<template>
  <v-navigation-drawer
    v-if="selectedModule"
    id="core-navigation-drawer"
    :style="`background-color: #343f53`"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage"
    mobile-breakpoint="960"
    app
    width="310"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img :gradient="`to bottom, ${barColor}`" v-bind="props" />
    </template>

    <v-divider />
    <div style="text-align: center; padding: 20px 0; cursor: pointer">
      <img
        @click="$router.push('/modulos')"
        src="../../../../assets/lg_grupo_w.png"
        width="40%"
      />
    </div>

    <v-divider class="mb-2" />

    <!-- Navega??o de M?dulos -->
    <div v-if="selectedModule" class="pa-3 pt-0">
      <v-card
        dark
        color="rgba(255,255,255,0.1)"
        class="mb-2"
        elevation="0"
        style="margin-top: 0 !important"
      >
        <div class="pa-3">
          <div class="d-flex align-center mb-2">
            <v-icon color="white" class="mr-2">{{ currentModuleIcon }}</v-icon>
            <div class="text-subtitle-2 font-weight-bold white--text">
              {{ selectedModuleName }}
            </div>
          </div>
          <div class="text-caption white--text mb-3">Módulo atual</div>
          <v-btn block outlined color="white" @click="backToModules" small>
            <v-icon left small>mdi-view-grid</v-icon>
            Trocar Módulo
          </v-btn>
        </div>
      </v-card>
    </div>

    <v-divider v-if="selectedModule" class="mb-2" />

    <v-list expand nav>
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

      <template v-for="(item, i) in computedItems">
        <!-- Divisor de seção -->
        <v-divider
          v-if="item.title === ''"
          :key="`divider-${i}`"
          class="my-2 mx-3 drawer-divider"
        />

        <!-- Cabeçalho de Grupo/Seção -->
        <div
          v-else-if="!item.to && !item.icon && !item.children"
          :key="`header-${i}`"
          class="drawer-section-header"
        >
          <span>{{ item.title }}</span>
        </div>

        <!-- Submenu / Grupo com filhos -->
        <base-item-group
          v-else-if="item.children"
          :key="`group-${i}`"
          :item="item"
        />

        <!-- Item de navegação comum -->
        <base-item
          v-else
          :key="`item-${i}`"
          :item="item"
        />
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
    </v-list>

    <v-divider class="mb-2" />
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapState } from "vuex";
import { drawerItems } from "@/config/navigationConfig";

export default {
  name: "DashboardCoreDrawer",

  props: {
    expandOnHover: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    promotores: [],
    user: "",

    items: drawerItems,
    /* REMOVIDO - Agora usando drawerItems de navigationConfig.js
    items: [
      {
        title: "Performance",
        roles: [
          "ROLE_RESUMO",
          "ROLE_CAMPANHA",
          "ROLE_CONTRATO",
          "ROLE_OBITO",
          "ROLE_SEPULTAMENTO",
          "ROLE_INADIMPLENCIA_PERFORMANCE",
          "ROLE_ACORDO_PERFORMANCE",
          "ROLE_SINISTRALIDADE",
          "ROLE_CONTAS",
        ],
      },

      {
        icon: "mdi-calculator",
        title: "Resumo",
        roles: ["ROLE_RESUMO"],
        to: "financeiro",
      },

      {
        icon: "mdi-file-document-check-outline",
        title: "Carteira",
        roles: ["ROLE_CONTRATO"],
        to: "contrato",
      },

      {
        icon: "mdi-coffin",
        title: "?bitos",
        roles: ["ROLE_OBITO"],
        to: "obito",
      },

      {
        icon: "mdi-flower",
        title: "Sepultamento",
        roles: ["ROLE_SEPULTAMENTO"],
        to: "sepultamento",
      },

      {
        icon: "mdi-cash-clock",
        title: "Inadimpl?ncia",
        roles: ["ROLE_INADIMPLENCIA_PERFORMANCE"],
        to: "inadimplenciaPerformance",
      },

      {
        icon: "mdi-handshake",
        title: "Acordos",
        roles: ["ROLE_ACORDO_PERFORMANCE"],
        to: "acordosPerformance",
      },

      {
        icon: "mdi-alert",
        title: "Sinistralidade",
        roles: ["ROLE_SINISTRALIDADE"],
        to: "sinistralidade",
      },

      {
        icon: "mdi-calculator",
        title: "Contas",
        roles: ["ROLE_CONTAS"],
        to: "contas",
      },

      {
        title: "",
      },

      {
        title: "Acompanhamento",
        roles: [
          "ROLE_AUDITORIA",
          "ROLE_COBRANCA",
          "ROLE_FATURAMENTO",
          "ROLE_ACOMPANHAMENTO_VENDA",
          "ROLE_REMESSA_NEGATIVADO",
          "ROLE_NEGATIVADO",
          "ROLE_COB_FUNERARIA",
          "ROLE_COB_RELACIONAMENTO",
          "ROLE_COB_SEPULTAMENTO",
          "ROLE_FUNERARIA",
          "ROLE_LOJA",
          "ROLE_RETENCAO",
          "ROLE_IMPORTACAO_CONSULTA",
          "ROLE_IMPORTACAO_DOWNLOAD",
          "ROLE_IMPORTACAO_FILE_STATUS",
          "ROLE_IMPORTACAO_FILE",
          "ROLE_GESTAO_CARTEIRA",
          "ROLE_FALECIDOS",
        ],
      },

      {
        icon: "mdi-marker",
        title: "Auditoria",
        roles: ["ROLE_AUDITORIA"],
        to: "auditoria",
      },

      {
        icon: "mdi-cash-refund",
        title: "Cobran?a",
        roles: ["ROLE_REMESSA_NEGATIVADO", "ROLE_COBRANCA", "ROLE_NEGATIVADO"],
        to: "cobranca",
        group: "",
        children: [
          {
            icon: "mdi-cash-refund",
            title: "Acordos",
            // roles: [ 'ROLE_COBRANCA'],
            to: "cobranca",
          },

          {
            title: "Negativados",
            //  roles: [ 'ROLE_NEGATIVADO'],
            to: "negativados",
          },

          {
            title: "Remessa Serasa",
            // roles: [ 'ROLE_REMESSA_NEGATIVADO'],
            to: "remessa",
          },
        ],
      },

      {
        icon: "mdi-finance",
        title: "Faturamento",
        roles: ["ROLE_FATURAMENTO"],
        to: "faturamento",
      },

      {
        icon: "mdi-toolbox-outline",
        title: "Servi?os Funer?rios",
        roles: ["ROLE_COB_FUNERARIA"],
        to: "",
      },

      {
        icon: "mdi-face-agent",
        title: "Relacionamento",
        roles: ["ROLE_COB_RELACIONAMENTO"],
        to: "",
      },

      {
        icon: "mdi-grave-stone",
        title: "Sepultamento",
        roles: ["ROLE_COB_SEPULTAMENTO"],
        to: "",
      },

      {
        icon: "mdi-sale",
        title: "Vendas",
        roles: ["ROLE_ACOMPANHAMENTO_VENDA"],
        to: "acompanhamentovenda",
      },

      {
        icon: "mdi-toolbox-outline",
        title: "Funer?ria",
        roles: ["ROLE_FUNERARIA"],
        to: "funeraria",
      },

      {
        icon: "mdi-store",
        title: "Loja",
        roles: ["ROLE_LOJA"],
        to: "loja",
      },

      {
        icon: "mdi-safe",
        title: "Reten??o de Vendas",
        roles: ["ROLE_RETENCAO"],
        to: "retencao",
      },
      {
        icon: "mdi-file-arrow-up-down-outline",
        title: "Arquivos",
        roles: [
          "ROLE_IMPORTACAO_CONSULTA",
          "ROLE_IMPORTACAO_DOWNLOAD",
          "ROLE_IMPORTACAO_FILE_STATUS",
          "ROLE_IMPORTACAO_FILE",
        ],
        to: "gestaoArquivos",
      },
      {
        icon: "mdi-wallet-outline",
        title: "Gest?o de Carteira",
        roles: ["ROLE_GESTAO_CARTEIRA"],
        to: "gestaoCarteira",
      },

      {
        icon: "mdi-grave-stone",
        title: "Falecidos",
        roles: ["ROLE_FALECIDOS"],
        to: "falecidos",
      },
      {
        title: "",
      },

      {
        title: "SAC",
        roles: [
          "ROLE_CHAT",
          "ROLE_CHAT_CONSULTA",
          "ROLE_ADMIN",
          "ROLE_ETIQUETA_CONSULTA",
          "ROLE_ETIQUETA_CADASTRO",
        ],
      },

      {
        icon: "mdi-chat",
        title: "Chat",
        roles: ["ROLE_CHAT"],
        to: "chat",
      },
      {
        icon: "mdi-chat",
        title: "Chat Receptivo",
        roles: ["ROLE_CHAT_RECEPTIVO"],
        to: "chat-wazzup",
      },
      {
        icon: "mdi-magnify",
        title: "Consulta",
        roles: ["ROLE_CHAT_CONSULTA"],
        to: "consulta-chat",
      },
      {
        icon: "mdi-format-list-bulleted",
        title: "Filas",
        roles: ["ROLE_CHAT_FILAS"],
        to: "filas",
      },
      {
        icon: "mdi-message-text-outline",
        title: "Templates",
        roles: ["ROLE_TEMPLATES"],
        to: "templates",
      },
      {
        icon: "mdi-tune",
        title: "Parâmetros",
        roles: [
          "ROLE_ADMIN",
          "ROLE_PARAMETROS",
          "ROLE_PARAMETROS_CONSULTA",
          "ROLE_PARAMETROS_CADASTRO",
          "ROLE_TEMPLATES",
        ],
        to: "parametros",
      },
      {
        icon: "mdi-robot",
        title: "URAs",
        roles: ["ROLE_URAS"],
        to: "uras",
      },
      {
        icon: "mdi-tag-multiple",
        title: "Etiquetas",
        roles: ["ROLE_ADMIN", "ROLE_ETIQUETA_CONSULTA", "ROLE_ETIQUETA_CADASTRO"],
        to: "etiquetas",
      },

      {
        title: "",
      },

      {
        title: "Central de Consultas",
        roles: ["ROLE_ADMIN", "ROLE_LEMIT_CONSULTA", "ROLE_LEMIT_SALDO", "ROLE_USER"],
      },

      {
        icon: "mdi-magnify-scan",
        title: "An?lise",
        roles: ["ROLE_ADMIN", "ROLE_LEMIT_CONSULTA"],
        to: "central-consultas-analise",
      },

      {
        icon: "mdi-cash-check",
        title: "Saldo",
        roles: ["ROLE_ADMIN", "ROLE_LEMIT_SALDO"],
        to: "central-consultas-saldo",
      },

      {
        icon: "mdi-chart-box-outline",
        title: "LTV",
        roles: ["ROLE_ADMIN", "ROLE_USER"],
        to: "consulta-ltv",
      },

      {
        title: "",
      },




      {
        title: "Comunica??o",
        roles: ["ROLE_BATEPAPO"],
      },
      {
        icon: "mdi-comment-account-outline",
        title: "Batepapo",
        roles: ["ROLE_BATEPAPO"],
        to: "batepapo",
      },

      {
        title: "",
      },

      {
        title: "Comiss?o",
        roles: [
          "ROLE_COMISSAO",
          "ROLE_COMISSAO_VENDA",
          "ROLE_COMISSAO_FUNERARIA",
          "ROLE_COMISSAO_ENTREGAS",
          "ROLE_COMISSAO_CONTROLE",
          "ROLE_VENDAS_RADAR",
        ],
      },

      {
        icon: "mdi-percent",
        title: "Acordos",
        roles: ["ROLE_COMISSAO"],
        to: "comissao",
      },

      {
        icon: "mdi-percent",
        title: "Vendas",
        roles: ["ROLE_COMISSAO_VENDA"],
        to: "comissaoVenda",
      },

      {
        icon: "mdi-percent",
        title: "Funer?ria",
        roles: ["ROLE_COMISSAO_FUNERARIA"],
        to: "comissaoFuneraria",
      },

      {
        icon: "mdi-percent",
        title: "Entregas",
        roles: ["ROLE_COMISSAO_ENTREGAS"],
        to: "comissaoEntrega",
      },

      {
        icon: "mdi-link-variant",
        title: "V?nculo",
        roles: ["ROLE_COMISSAO_CONTROLE"],
        to: "comissaoControle",
      },

      {
        icon: "mdi-alert-octagon",
        title: "Ocorr?ncia",
        roles: ["ROLE_COMISSAO_CONTROLE"],
        to: "comissaoConformidade",
      },

      {
        icon: "mdi-sale",
        title: "Vendas Radar",
        roles: ["ROLE_VENDAS_RADAR"],
        to: "vendasRadar",
      },

      {
        title: "",
      },

      {
        title: "Colaboradores",
        roles: ["ROLE_COMISSAO_ALELO", "ROLE_GRUPOS_COLABORADORES"],
      },

      {
        icon: "mdi-gift",
        title: "Comiss?es Alelo",
        roles: ["ROLE_COMISSAO_ALELO"],
        to: "comissaoAlelo",
      },
      {
        icon: "mdi-account-multiple",
        title: "Grupos de Colaboradores",
        roles: ["ROLE_GRUPOS_COLABORADORES"],
        to: "gruposColaboradores",
      },

      {
        title: "",
      },

      {
        title: "Bitrix",
        roles: ["ROLE_BITRIX"],
      },

      {
        icon: "mdi-account-multiple",
        title: "Leads",
        roles: ["ROLE_BITRIX"],
        to: "bitrixLead",
      },

      {
        title: "",
      },

      {
        title: "Consulta Gen?rica",
        roles: [
          "ROLE_RECEITA",
          "ROLE_INADIMPLENCIA",
          "ROLE_VENDA",
          "ROLE_CANCELAMENTO",
          "ROLE_RENEGOCIACAO",
          "ROLE_VENDAS_EMPRESA",
          "ROLE_MANUTENCAO_DOC",
        ],
      },

      {
        icon: "mdi-cash",
        title: "Receita",
        roles: ["ROLE_RECEITA"],
        to: "receita",
      },
      {
        icon: "mdi-filter-variant",
        title: "Consulta Dinamica",
        roles: ["ROLE_RECEITA"],
        to: "consultaDinamica",
      },

      {
        icon: "mdi-cash-clock",
        title: "Inadimpl?ncia",
        roles: ["ROLE_INADIMPLENCIA"],
        to: "inadimplencia",
      },

      {
        icon: "mdi-sale",
        title: "Vendas",
        roles: ["ROLE_VENDA"],
        to: "venda",
      },

      {
        icon: "mdi-sale",
        title: "Entre Empresas",
        roles: ["ROLE_VENDAS_EMPRESA"],
        to: "vendasEmpresas",
      },

      {
        icon: "mdi-delete",
        title: "Cancelamentos",
        roles: ["ROLE_CANCELAMENTO"],
        to: "cancelamento",
      },

      {
        icon: "mdi-handshake",
        title: "Renegocia??o",
        roles: ["ROLE_RENEGOCIACAO"],
        to: "acordos",
      },

      {
        icon: "mdi-text-box-search-outline",
        title: "Documentos",
        roles: ["ROLE_MANUTENCAO_DOC"],
        to: "documentos",
      },

      {
        title: "",
      },

      {
        title: "Stratws",
        roles: ["ROLE_STRATUS"],
      },
      {
        icon: "mdi-finance",
        title: "Indicadores",
        roles: ["ROLE_STRATUS"],
        to: "indicadores",
      },
      {
        icon: "mdi-cloud-upload",
        title: "Importa??o Stratws",
        roles: ["ROLE_STRATUS"],
        to: "importacao-stratws",
      },

      {
        title: "",
      },

      {
        title: "Invita",
        roles: ["ROLE_DS"],
      },
      {
        icon: "mdi-file",
        title: "Arquivos DS",
        roles: ["ROLE_DS"],
        to: "invita",
      },
      {
        title: "",
      },
      {
        title: "GLPI",
        roles: ["ROLE_GLPI"],
      },
      {
        icon: "mdi-clipboard-text-search-outline",
        title: "Consulta GLPI",
        roles: ["ROLE_GLPI"],
        to: "consulta-glpi",
      },
      {
        icon: "mdi-account-group",
        title: "Acompanhamento por Setor",
        roles: ["ROLE_GLPI"],
        to: "acompanhamento-glpi",
      },

      {
        title: "",
      },
      {
        title: "Mensageria",
        roles: ["ROLE_MENSAGERIA_CLIENTE", "ROLE_MENSAGERIA_COLABORADOR", "ROLE_MENSAGERIA_LOTE", "ROLE_MENSAGERIA_ANIVERSARIO", "ROLE_MENSAGERIA_CONSULTA"],
      },
      {
        icon: "mdi-account-arrow-right",
        title: "Disparos Clientes",
        roles: ["ROLE_MENSAGERIA_CLIENTE"],
        to: "mensageria-externa",
      },
      {
        icon: "mdi-receipt-text-send",
        title: "Disparos Colaboradores",
        roles: ["ROLE_MENSAGERIA_COLABORADOR"],
        to: "mensageria-interna",
      },
      {
        icon: "mdi-email-multiple",
        title: "Disparo em Lote",
        roles: ["ROLE_MENSAGERIA_LOTE"],
        to: "mensageria-lote",
      },
      {
        icon: "mdi-cake",
        title: "Disparo Anivers?rio",
        roles: ["ROLE_MENSAGERIA_ANIVERSARIO"],
        to: "mensageria-aniversario",
      },
      {
        icon: "mdi-magnify",
        title: "Consulta",
        roles: ["ROLE_MENSAGERIA_CONSULTA"],
        to: "mensageria-consulta",
      },
      {
        title: "",
      },
      {
        title: "Fluxo de Servi?os",
        roles: ["ROLE_SERVICO_FUNERARIO", "ROLE_SERVICO_FUNERARIO_EDICAO", "ROLE_FLUXO_DEVOLVIDO"],
      },
      {
        icon: "mdi-coffin",
        title: "Funer?ria",
        roles: ["ROLE_SERVICO_FUNERARIO", "ROLE_SERVICO_FUNERARIO_EDICAO"],
        to: "fluxo-servico-funerario",
      },
      {
        icon: "mdi-file-rotate-left",
        title: "Faturamento",
        roles: ["ROLE_FLUXO_DEVOLVIDO"],
        to: "fluxo-carne-devolvidos",
      },

      {
        title: "",
      },

      {
        title: "Relatórios",
        roles: [
          "ROLE_SERVICO_FUNERARIO",
          "ROLE_SERVICO_FUNERARIO_EDICAO",
          "ROLE_SERVICO_FUNERARIO_RELATORIO",
          "ROLE_SERVICO_FUNERARIO_RELATORIO_AGENTE",
          "ROLE_ADMIN",
        ],
      },

      {
        icon: "mdi-clipboard-pulse-outline",
        title: "Funerário",
        roles: [
          "ROLE_SERVICO_FUNERARIO",
          "ROLE_SERVICO_FUNERARIO_EDICAO",
          "ROLE_SERVICO_FUNERARIO_RELATORIO",
          "ROLE_SERVICO_FUNERARIO_RELATORIO_AGENTE",
          "ROLE_ADMIN",
        ],
        to: "relatorio-funerario",
      },

      {
        title: "",
      },

      {
        title: "Financeiro",
        roles: [
          "ROLE_IMPORTACAO_RADAR",
          "ROLE_IMPORTACAO_RADAR_APP",
          "ROLE_FLUXO",
          "ROLE_CONCILIACAO",
          "ROLE_DOCUEMNTOS_IVERTEX",
        ],
      },

      {
        icon: "mdi-finance",
        title: "Fluxo",
        roles: ["ROLE_FLUXO"],
        to: "fluxo",
      },

      {
        icon: "mdi-cash-clock",
        title: "Radar Documentos",
        roles: ["ROLE_IMPORTACAO_RADAR"],
        to: "importacao",
      },

      {
        icon: "mdi-cash-clock",
        title: "Importa??o Radar",
        roles: ["ROLE_IMPORTACAO_RADAR_APP"],
        to: "importacaoapp",
      },

      {
        icon: "mdi-cash-clock",
        title: "Concilia??o",
        roles: ["ROLE_CONCILIACAO"],
        to: "conciliacao",
      },

      {
        icon: "mdi-text-box-search-outline",
        title: "Documentos",
        roles: ["ROLE_DOCUEMNTOS_IVERTEX"],
        to: "documentos",
      },
      {
        title: "",
      },

      {
        title: "Administrador",
        roles: [
          "ROLE_NOTIFICACAO",
          "ROLE_LOG",
          "ROLE_USER",
          "ROLE_COLABORADORES",
        ],
      },

      {
        icon: "mdi-account-multiple",
        title: "Colaboradores",
        roles: ["ROLE_COLABORADORES"],
        to: "colaboradores",
      },
      {
        icon: "mdi-bell",
        title: "Notifica??o",
        roles: ["ROLE_NOTIFICACAO"],
        to: "notificacao",
      },

      {
        icon: "mdi-history",
        title: "LOG",
        roles: ["ROLE_LOG"],
        to: "historico",
      },

      {
        icon: "mdi-account",
        title: "Usu?rio",
        roles: ["ROLE_USER"],
        to: "usuario",
      },

      {
        title: "",
      },

      {
        title: "Configura??es",
      },

      {
        icon: "mdi-key",
        title: "Alterar Senha",
        to: "register",
      },

      {
        icon: "mdi-logout",
        title: "Sair",
        to: "login",
      },
    ], */
  }),

  computed: {
    ...mapState(["barColor", "barImage"]),
    drawer: {
      get() {
        //  return true;
        //alert('.....'+this.$store.state.drawer)
        return this.$store.state.drawer;
      },
      set(val) {
        //alert(val)
        this.$store.commit("SET_DRAWER", val);
      },
    },

    descobrirUser() {
      this.user = JSON.parse(sessionStorage.getItem("user"));
    },

    selectedModule() {
      return this.$store.state.selectedModule;
    },

    selectedModuleName() {
      return this.selectedModule?.name || "Módulo";
    },

    currentModuleIcon() {
      return this.selectedModule?.icon || "mdi-folder";
    },

    moduleColor() {
      return this.selectedModule?.color || "rgb(71 130 180)";
    },

    computedItems() {
      // Se nenhum m?dulo estiver selecionado, n?o mostra nada no menu
      const selectedModule = this.$store.state.selectedModule;

      if (!selectedModule) {
        return [];
      }

      let mappedItems = this.items.map(this.mapItem).filter(Boolean);

      if (selectedModule.groups) {
        mappedItems = this.filterByModule(mappedItems, selectedModule.groups);
      }

      // Remove dividers do in?cio
      while (mappedItems.length && mappedItems[0].title === "") {
        mappedItems.shift();
      }

      // Remove dividers do fim
      while (
        mappedItems.length &&
        mappedItems[mappedItems.length - 1].title === ""
      ) {
        mappedItems.pop();
      }

      // Remove dividers duplicados no meio
      const result = [];
      let lastWasDivider = false;

      for (const item of mappedItems) {
        const isDivider = item.title === "";

        if (isDivider && lastWasDivider) continue;

        result.push(item);
        lastWasDivider = isDivider;
      }

      return result;
    },

    profile() {
      return {
        avatar: true,
        title: this.$t("avatar"),
      };
    },
  },

  methods: {
    mapItem(item) {
      if (this.user == "") {
        this.user = JSON.parse(sessionStorage.getItem("user"));
      }

      const hasPermission = this.checkPermission(item);

      let modifiedItem = { ...item };

      // Lista de rotas que voc? quer garantir que sejam absolutas
      const rotasAbsolutas = ["cobranca", "negativados", "remessa", "relatoriosSeguro", "configRelatoriosSeguro"];
      if (
        modifiedItem.to &&
        typeof modifiedItem.to === "string" &&
        !rotasAbsolutas.includes(modifiedItem.to.replace(/^\/+/, "")) // s? corrige se N?O estiver na lista
      ) {
        // Corrige para sempre uma ?nica barra
        modifiedItem.to = "/" + modifiedItem.to.replace(/^\/+/, "");
      }

      return hasPermission
        ? {
            ...modifiedItem,
            children: modifiedItem.children
              ? modifiedItem.children.map(this.mapItem)
              : undefined,
            title: this.$t(modifiedItem.title),
          }
        : null;
    },

    checkPermission(item) {
      // Verifica se o usu?rio est? definido e se tem a permiss?o especificada em 'role' ou 'ROLE_ADMIN'
      return (
        (this.user &&
          this.user.roles &&
          Array.isArray(this.user.roles) && // Certifica-se de que this.user.roles ? um array
          (item.roles
            ? item.roles.some((role) => this.user.roles.includes(role))
            : true)) ||
        this.user.roles.includes("ROLE_ADMIN")
      );
    },

    ranking() {},

    logout() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },

    backToModules() {
      this.$store.commit("clearSelectedModule");
      this.$router.push("/modulos");
    },

    filterByModule(items, allowedGroups) {
      const result = [];
      const fixedGroups = [];
      let currentGroupItem = null;
      let groupItems = [];

      // Grupos que sempre devem aparecer no final
      const alwaysShowGroups = [
        "Administrador",
        "Configurações",
        "GED",
        "Comunicação Interna",
      ];

      const pushGroup = (target, groupItem, itemsOfGroup) => {
        target.push({
          title: groupItem.title,
          isBeta: groupItem.isBeta,
          roles: groupItem.roles,
        });
        target.push(...itemsOfGroup);
      };

      for (const item of items) {
        // Se é um divisor vazio, fecha o grupo atual para não vazar itens entre seções
        if (item.title === "") {
          if (currentGroupItem) {
            const currentGroup = currentGroupItem.title;
            const isFixed = alwaysShowGroups.includes(currentGroup);
            const isAllowed = allowedGroups.includes(currentGroup);

            if (isFixed) {
              pushGroup(fixedGroups, currentGroupItem, groupItems);
            } else if (isAllowed) {
              const hasMenuItems = groupItems.some((groupItem) => groupItem.to);
              if (hasMenuItems) {
                pushGroup(result, currentGroupItem, groupItems);
              }
            }
            currentGroupItem = null;
            groupItems = [];
          }
          continue;
        }

        // Se é um título de grupo (sem ícone e sem rota)
        if (item.title && !item.to && !item.icon) {
          // Se temos um grupo anterior, processa ele
          if (currentGroupItem) {
            const currentGroup = currentGroupItem.title;
            const isFixed = alwaysShowGroups.includes(currentGroup);
            const isAllowed = allowedGroups.includes(currentGroup);

            if (isFixed) {
              pushGroup(fixedGroups, currentGroupItem, groupItems);
            } else if (isAllowed) {
              const hasMenuItems = groupItems.some((groupItem) => groupItem.to || (groupItem.children && groupItem.children.length > 0));
              if (hasMenuItems) {
                pushGroup(result, currentGroupItem, groupItems);
              }
            }
          }

          // Inicia novo grupo
          currentGroupItem = item;
          groupItems = [];
        } else if (currentGroupItem) {
          // Adiciona item ao grupo atual
          groupItems.push(item);
        }
      }

      // Processa último grupo
      if (currentGroupItem) {
        const currentGroup = currentGroupItem.title;
        const isFixed = alwaysShowGroups.includes(currentGroup);
        const isAllowed = allowedGroups.includes(currentGroup);

        if (isFixed) {
          pushGroup(fixedGroups, currentGroupItem, groupItems);
        } else if (isAllowed) {
          const hasMenuItems = groupItems.some((groupItem) => groupItem.to || (groupItem.children && groupItem.children.length > 0));
          if (hasMenuItems) {
            pushGroup(result, currentGroupItem, groupItems);
          }
        }
      }

      // Adiciona grupos fixos no final
      return [...result, ...fixedGroups];
    },
  },
};
</script>

<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'

#core-navigation-drawer
  .v-list-group
    margin-bottom: 6px

    &__header
      min-height: 42px
      margin-bottom: 2px

      &.v-list-item--active:before
        opacity: .24

      .v-list-item__icon.v-list-group__header__append-icon
        margin-top: 10px
        margin-bottom: 8px
        min-width: 20px
        justify-content: center

        .v-icon
          font-size: 18px

    &__items
      padding: 4px 0

      .v-list-item
        min-height: 38px
        margin-top: 2px
        margin-bottom: 4px !important
        font-size: 13px

        +ltr()
          padding-left: 28px !important
        +rtl()
          padding-right: 28px !important

        .v-list-item__title
          font-size: 13px !important
          line-height: 1.35
          font-weight: 400

        .v-list-item__icon
          margin-top: 8px !important
          margin-bottom: 8px !important

        .v-list-item__icon--text
          margin-top: 8px !important
          margin-bottom: 8px !important
          font-size: 11px
          font-weight: 600
          letter-spacing: 0.5px
          opacity: 0.85
          width: 20px
          min-width: 20px
          height: 20px
          line-height: 20px
          justify-content: center
          text-align: center

          +ltr()
            margin-right: 16px !important
            margin-left: 4px !important
          +rtl()
            margin-left: 16px !important
            margin-right: 4px !important

  .v-list-item
    min-height: 42px
    margin-bottom: 4px

    &__icon--text,
    &__icon:first-child
      justify-content: center
      text-align: center
      width: 24px
      min-width: 24px
      margin-top: 9px
      margin-bottom: 9px

      +ltr()
        margin-right: 18px
        margin-left: 6px !important

      +rtl()
        margin-left: 18px
        margin-right: 6px !important

  .v-list--dense
    .v-list-item
      &__icon--text,
      &__icon:first-child
        margin-top: 7px
        margin-bottom: 7px

  .v-list-group--sub-group
    .v-list-group__items
      .v-list-item
        +ltr()
          padding-left: 44px !important
        +rtl()
          padding-right: 44px !important

    .v-list-group__header
      +ltr()
        padding-left: 28px !important
        padding-right: 0
      +rtl()
        padding-right: 28px !important
        padding-left: 0
  
      .v-list-item__icon--text
        margin-top: 9px
        order: 0

      .v-list-group__header__prepend-icon
        order: 2
        margin-top: 9px
        margin-bottom: 9px

        +ltr()
          margin-right: 8px
        +rtl()
          margin-left: 8px

  .drawer-section-header
    font-size: 0.72rem !important
    font-weight: 700
    text-transform: uppercase
    letter-spacing: 0.08em
    color: rgba(255, 255, 255, 0.55)
    padding: 26px 14px 6px 14px
    line-height: 1.4
    user-select: none

  .drawer-divider
    background-color: rgba(255, 255, 255, 0.12) !important
    border-color: rgba(255, 255, 255, 0.12) !important
    margin-top: 10px !important
    margin-bottom: 10px !important
</style>
